// Converts from degrees to radians.
function toRadians(degrees: number) {
  return (degrees * Math.PI) / 180
}

// Converts from radians to degrees.
function toDegrees(radians: number) {
  return (radians * 180) / Math.PI
}

/**
 *
 * @param source The source co-ordinate eg. {lat: 0, lng: 0}
 * @param destination The destination co-ordinate eg. {lat: 0, lng: 0}
 * @returns The bearing angle between the source and destination co-ordinates
 * @author Malik Bagwala <malik.bagwala@vesatogo.com>
 * @example
 * import bearing from "utils/bearing"
 *
 * const angle = bearing({lat: 0, lng: 0}, {lat: 0, lng: 0})
 */

type Point = {
  lat: number
  lng: number
}
function bearing(source: Point, destination: Point) {
  if (!source?.lat || !source?.lng) return 0
  if (!destination?.lat || !destination?.lng) return 0

  const startLat = toRadians(source.lat)
  const startLng = toRadians(source.lng)
  const destLat = toRadians(destination.lat)
  const destLng = toRadians(destination.lng)

  const y = Math.sin(destLng - startLng) * Math.cos(destLat)
  const x =
    Math.cos(startLat) * Math.sin(destLat) -
    Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng)

  const brng = toDegrees(Math.atan2(y, x))

  return ((brng + 360) % 360) - 90
}

export default bearing
